/**
 * Created by user on 2020/6/11.
 */

import CliTable from 'cli-table3';

export * from './lib/types';
export * from './lib/deps-table';
export * from './lib/core';
export * from './lib/style';

export { CliTable }
export { CliTable as Table }

export default CliTable
